import {eventEmitter, lang, sessid} from "../../common/baseData";

class Product {
	constructor(holder) {
		this.holder = holder;
		this.basketItemsMap = false;
	}

	set holder(el) {
		this._holder = el;
	}

	get mainElement() {
		return this._holder;
	}

	set data(data) {
		this._data = data;
	}

	get data() {
		return this._data;
	}

	decodeData(data) {
		return JSON.parse(atob(data));
	}

	get detailPopupTriggerElements() {
		this._detailPopupTriggerElements = [].slice.apply(this._holder.querySelectorAll('.js-product-modal'));
		return this._detailPopupTriggerElements;
	}

	get picturesBox() {
		if (!this._picturesBox) {
			this._picturesBox = this._holder.querySelector('.product-imgs-holder');
		}
		return this._picturesBox;
	}

	get previewPicturesBox() {
		if (!this._previewPicturesBox) {
			this._previewPicturesBox = this._holder.querySelector('.product-preview-holder');
		}
		return this._previewPicturesBox;
	}

	get pictures() {
		return this._data.MORE_PHOTO;
	}

	get name() {
		return this._data.NAME;
	}

	get messages() {
		return this._data.messages;
	}

	message(code) {
		return (this.messages[code]) ? this.messages[code] : 'Unknown message';
	}

	hasOldPrice() {
		return (parseInt(this._data['PROPERTIES']['STARAYA_TSENA_V_']['VALUE'], 10) > 0);
	}

	get price() {
		parseInt(this._data['PRICES']['Интернет USD']['DISCOUNT_VALUE'], 10);
	}

	get oldPrice() {
		return parseInt(this._data['PRICES']['Интернет USD']['DISCOUNT_VALUE'], 10) + parseInt(this._data['PRICES']['Интернет USD']['DISCOUNT_VALUE'], 10) * parseInt(this._data["PROPERTIES"]["STARAYA_TSENA_V_"]["VALUE"], 10) / 100;
	}

	loadPopupTemplate() {
		let body = new FormData();
		body.append('template', this._data.template);
		body.append('parameters', this._data.parameters);
		body.append('lang', lang);
		body.append('sessid', sessid);
		return fetch(this._data.ajaxComponentPath, {
			method: 'POST',
			body: body
		});
	}

	updateState() {
		let self = this;
		// Update buttons state
		[].slice.apply(document.querySelectorAll('.product-scroll [data-container="buy"], .product-info-section [data-container="buy"], .product-info-panel [data-container="buy"], .about-product-purchase [data-container="buy"]'))
			.forEach(buyButton => {
				let productId = buyButton.dataset.productId;
				if (buyButton instanceof HTMLElement && buyButton.dataset.use === 'order')
					self.updateBuyButtonState(buyButton, productId);
		});
		return this;
	}

	/**
	 * Check product exist in basket, update button state
	 * @param button
	 * @param productId
	 * @returns {ProductsListSmallCard}
	 */
	updateBuyButtonState(button, productId) {
		let basketItemsMapJsonString = window.localStorage.getItem('basketItemsMap');
		let basketItemsMap = (basketItemsMapJsonString) ? JSON.parse(basketItemsMapJsonString) : false;

		if ((basketItemsMap === false && this._data.IN_BASKET) || basketItemsMap.hasOwnProperty(productId)) {
			button.classList.add('in-basket');
			button.innerHTML = `<span class="btn-text" onclick="this.parentNode.click();">${this.message('PRODUCT_IN_BASKET_TITLE')}</span>
													<i class="icon-basket_blue" onclick="this.parentNode.click();"></i>`;
		} else {
			button.classList.remove('in-basket');
			button.innerHTML = `<i class="icon-basket_white" onclick="this.parentNode.click();"></i>
													<span class="btn-text" onclick="this.parentNode.click();">${this.message('PRODUCT_BUY_TITLE')}</span>`;
		}
		return this;
	}

	initEvents() {
		let self = this;
		// Обновление кнопок купить / в корзине
		eventEmitter.on('basketUpdated', data => {
			self.updateState();
		});
		// Обновление состояния кнопок купить
		self.updateState();
	}

	initStickly() {
		if (this._panelScrollHandler) {
			window.removeEventListener('scroll', this._panelScrollHandler);
			this._panelScrollHandler = null;
		}

		let windowWidth = window.innerWidth
			|| document.documentElement.clientWidth
			|| document.body.clientWidth;


		// fixed product-item main photo
		window.onscroll = function() {
			fixedScroll();
			activeNavigationItem();
		};
		window.onresize = function() {
				windowWidth = window.innerWidth
						|| document.documentElement.clientWidth
						|| document.body.clientWidth;
				fixedScroll();
			activeNavigationItem();
		};


		let headerElem = document.querySelector(".product-item-detail-slider-container");
		let headerMain = document.querySelector(".product-view");
		let productInfo = document.querySelector(".product-info-section");
		var headerMainPaddingTop = parseInt(getComputedStyle(headerMain, true).paddingTop);
		let sticky = headerMain.offsetTop + headerMainPaddingTop;
		let tabletStickyStart = 0;

		if (typeof ResizeObserver !== 'undefined') {
			let productInfoResizeObserver = new ResizeObserver(() => {
				window.requestAnimationFrame(fixedScroll);
			});

			productInfoResizeObserver.observe(productInfo);
		}


		function fixedScroll() {
			let sliderContainerHeight = document.querySelector('.product-item-detail-slider-container').clientHeight;
			let aboutProductTitle = document.querySelector('.about-product-titles.desktop').clientHeight;
			let topPos = document.querySelector('.product-card-section');
			let headerElemPosition = getComputedStyle(headerElem).position;

			if (topPos.getBoundingClientRect().bottom < 0) {
				topPos.classList.add('active-full-width')
			} else {
				topPos.classList.remove('active-full-width')
			}

			if(windowWidth > 1024 && sliderContainerHeight + 132 < getProductInfoContentHeight()) { // 132 это сумма высоты отступов и блока с кнопка избранное и сравнение
						let sliderTopOffset = aboutProductTitle - 44;
						let headerMainTop = headerMain.getBoundingClientRect().top + window.pageYOffset + headerMainPaddingTop;
						let headerMainBottom = headerMain.getBoundingClientRect().top + window.pageYOffset + headerMain.offsetHeight;
						let endBlockFinall = headerMainBottom - sliderContainerHeight - 30 - sliderTopOffset;
						if (window.pageYOffset > headerMainTop - sliderTopOffset && window.pageYOffset < endBlockFinall) {
								headerElem.classList.add("sticky");
								headerElem.style.cssText =  '';
						} else if (window.pageYOffset > (endBlockFinall - 5)) {
								headerElem.classList.remove("sticky");
								headerElem.style.cssText = 'position: absolute; bottom: 0; top: unset;';
						} else {
								headerElem.classList.remove("sticky");
						}
				} else if (windowWidth > 1024) {
						headerElem.classList.remove("sticky");
						headerElem.style.cssText = '';
				} else if (windowWidth < 1023 && windowWidth > 768) {
						let endBlockMob = document.querySelector('.product-card-delivery').getBoundingClientRect().top - topPos.offsetTop - 30;

						let tabletStickyTopOffset = document.querySelector('.main.mobile_banner') ? 155 : 123;

						if (headerElemPosition !== 'fixed' && headerElemPosition !== 'absolute') {
							tabletStickyStart = headerElem.getBoundingClientRect().top + window.pageYOffset - tabletStickyTopOffset;
						}

						if (window.pageYOffset > tabletStickyStart && endBlockMob > sliderContainerHeight) {
								headerElem.classList.add("sticky");
								headerElem.style.cssText =  '';
						} else if (endBlockMob < sliderContainerHeight) {
								headerElem.classList.remove("sticky");
								headerElem.style.cssText = 'position: absolute; bottom: 0; top: unset;';
						} else {
								headerElem.classList.remove("sticky");
						}
				}
		}

		function getProductInfoContentHeight() {
			let productInfoRect = productInfo.getBoundingClientRect();
			let productInfoStyle = getComputedStyle(productInfo);
			let contentBottom = 0;

			[].slice.apply(productInfo.children).forEach(child => {
				let childStyle = getComputedStyle(child);
				if (childStyle.display === 'none' || childStyle.position === 'absolute' || childStyle.position === 'fixed') return;

				let childRect = child.getBoundingClientRect();
				let childBottom = childRect.bottom - productInfoRect.top + (parseInt(childStyle.marginBottom, 10) || 0);
				contentBottom = Math.max(contentBottom, childBottom);
			});

			return Math.ceil(contentBottom + (parseInt(productInfoStyle.paddingBottom, 10) || 0));
		}

		function activeNavigationItem() {
			let adaptiveClass = windowWidth > 767 ? '-d' : '';

			const buttons = {
				about: document.querySelector(`.section-about${adaptiveClass}`),
				characteristics: document.querySelector(`.section-characteristics${adaptiveClass}`),
				description: document.querySelector(`.section-description${adaptiveClass}`),
				testimonial: document.querySelector(`.section-testimonials${adaptiveClass}`)
			};

			const sections = {
				characteristics: document.querySelector('#section-characteristics-anchor'),
				description: document.querySelector('#product-description-root'),
				testimonial: document.querySelector('#product-reviews-root'),
				end: document.querySelector('#section-testimonials-bottom') ||
					document.querySelector('#section-testimonial-bottom')
			};

			if (!buttons.about || !sections.characteristics || !sections.description || !sections.testimonial) return;

			const scrollPosition = window.pageYOffset;
			const offset = 120;

			const positions = {
				characteristics: sections.characteristics.getBoundingClientRect().top + scrollPosition,
				description: sections.description.getBoundingClientRect().top + scrollPosition,
				testimonial: sections.testimonial.getBoundingClientRect().top + scrollPosition,
				end: sections.end ?
					sections.end.getBoundingClientRect().top + scrollPosition : document.documentElement.scrollHeight
			};

			// Удаляем класс active у всех кнопок
			Object.values(buttons).forEach(btn => btn && btn.classList.remove('active'));

			// Если скролл достиг конечного блока, выходим без добавления активного класса
			if (scrollPosition >= positions.end - offset) return;

			// Определяем активную кнопку на основе текущей позиции
			let activeButton = buttons.about; // По умолчанию активна первая кнопка

			if (scrollPosition >= positions.testimonial - offset) {
				activeButton = buttons.testimonial;
			} else if (scrollPosition >= positions.description - offset) {
				activeButton = buttons.description;
			} else if (scrollPosition >= positions.characteristics - offset) {
				activeButton = buttons.characteristics;
			}

			if (activeButton) activeButton.classList.add('active');
		}
		// end fixed product-item main photo


		const pageTop = element => element ? element.getBoundingClientRect().top + window.pageYOffset : null;
		const setActive = (selector, active) => document.querySelectorAll(selector)
			.forEach(element => element.classList.toggle('active', active));

		if (windowWidth > 1024 && document.querySelector('.product-scroll-item')) {
			const menuTitles = document.querySelector('.about-product-titles');
			const menuPanel = menuTitles ? menuTitles.offsetHeight : 0;
			const scrollItem = document.querySelector('.product-scroll-item');
			const aboutDescription = document.querySelector('#about-product-description');

			window.addEventListener('scroll', function() {
				let $top = window.pageYOffset + 30,
						activeTop = window.pageYOffset + 120,
						pip = pageTop(document.querySelector('.product-scroll-end')),
						characteristicsTop = pageTop(document.querySelector('#section-characteristics-anchor')),
						descriptionTop = pageTop(document.querySelector('#product-description-root')),
						testimonialsTop = pageTop(document.querySelector('#product-reviews-root')),
						height = scrollItem.offsetHeight,
						aboutTop = pageTop(aboutDescription);

				if (pip === null || characteristicsTop === null || descriptionTop === null || testimonialsTop === null)
					return;

				if ($top + 45 > aboutTop && $top < pip - height - menuPanel) {
					scrollItem.classList.add('sticky');
					scrollItem.removeAttribute('style');
				} else if ($top > pip - height - menuPanel) {
					scrollItem.classList.remove('sticky');
					Object.assign(scrollItem.style, {position: 'absolute', bottom: '0'});
				} else {
					scrollItem.classList.remove('sticky');
				}

				if ($top > aboutTop && $top < pip - 200) {
						menuTitles?.closest('.description-column')?.classList.add('fixed-menu');
						setActive('.about-product-titles.desktop .about-product-title', false);

						if (activeTop >= testimonialsTop) {
								setActive('.section-testimonials-d', true);
						} else if (activeTop >= descriptionTop) {
								setActive('.section-description-d', true);
						} else if (activeTop >= characteristicsTop) {
								setActive('.section-characteristics-d', true);
						} else {
								setActive('.section-about-d', true);
						}
				} else {
						menuTitles?.closest('.description-column')?.classList.remove('fixed-menu');
						setActive('.section-about-d', false);
				}
			}, {passive: true});
		} else if (windowWidth <= 1024 && document.querySelector('.product-info-panel')) {
					const panelBar = document.querySelector('.product-info-panel');
					const setPanelVisible = visible => Object.assign(panelBar.style, {
						transform: visible ? 'translateY(0)' : 'translateY(calc(100% + 120px))',
						transition: 'transform .2s ease-in-out',
						zIndex: visible ? '20' : '4'
					});
					const scrollThreshold = 5;
					let scrollDistance = 0;
					let scrollDirection = 0;
					const getViewportHeight = () => window.visualViewport
						? window.visualViewport.height
						: document.documentElement.clientHeight;

				// fixed buy btn , like on nike page
				let mainBtnContainer = document.querySelector('.product-info-section .main-button-container');
				var box = mainBtnContainer ? mainBtnContainer.querySelector('.buy-btn') : null;
				if (box instanceof HTMLElement) {
					let boxHeight = box.getBoundingClientRect()
					if (mainBtnContainer != null) {
						if (boxHeight.top > getViewportHeight() || boxHeight.bottom < 0) {
							setPanelVisible(true);
						} else {
							setPanelVisible(false);
						}
					}
				}

				let prevScrollPos = window.pageYOffset;
				this._panelScrollHandler = function () {

						let currentScrollPos = window.pageYOffset;
						let scrollDelta = currentScrollPos - prevScrollPos;
						let currentDirection = Math.sign(scrollDelta);

						if (currentDirection !== 0) {
							if (currentDirection !== scrollDirection) {
								scrollDirection = currentDirection;
								scrollDistance = scrollDelta;
							} else {
								scrollDistance += scrollDelta;
							}
						}

							var box = mainBtnContainer ? mainBtnContainer.querySelector('.buy-btn') : null;
							if (box instanceof HTMLElement) {
								let boxHeight = box.getBoundingClientRect();
								if (mainBtnContainer != null) {
									let boxOutsideViewport = boxHeight.top > getViewportHeight() || boxHeight.bottom < 0;

									if (boxOutsideViewport && scrollDistance >= scrollThreshold) {
										setPanelVisible(true);
									} else if (!boxOutsideViewport || scrollDistance <= -scrollThreshold) {
										//panelBar.fadeOut(0);
										setPanelVisible(false);
									}
								}
							}
						prevScrollPos = currentScrollPos;


						let $topMob = window.pageYOffset,
								aboutBottomMob = pageTop(document.querySelector('#section-about-bottom')),
								characteristicsBottomMob = pageTop(document.querySelector('#section-characteristics-bottom')),
								testimonialsBottomMob = pageTop(document.querySelector('#section-testimonials-bottom')),
								aboutSectionTop = pageTop(document.querySelector('.about-product-section'));
						if (aboutBottomMob !== null) aboutBottomMob -= 150;
						if (characteristicsBottomMob !== null) characteristicsBottomMob -= 150;

						if (aboutBottomMob === null || characteristicsBottomMob === null || testimonialsBottomMob === null)
							return;

							setActive('.about-product-titles.mob .about-product-title.section-about', $topMob > aboutSectionTop - 120 && $topMob < aboutBottomMob);
							setActive('.about-product-titles.mob .section-characteristics', $topMob > aboutBottomMob && $topMob < characteristicsBottomMob);
							setActive('.about-product-titles.mob .section-testimonials', $topMob > characteristicsBottomMob && $topMob < testimonialsBottomMob);
				};

				window.addEventListener('scroll', this._panelScrollHandler, {passive: true});
		}
	}
}



export {Product}